import React, { memo, useRef, useState } from "react";
import { Button, Chip } from "@mui/material";
import useChipsResize from "./useChipResize";

const MemoizedChip = memo(Chip);

const ExpandableChips = ({
  items,
  containerClass = "",
  defaultMaxVisibleChips = 5,
}) => {
  const containerRef = useRef(null);
  const seeMoreRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  const { maxVisibleChips, chipRefs } = useChipsResize({
    items,
    containerRef,
    seeMoreRef,
    defaultMaxVisibleChips,
  });

  const displayedItems = expanded ? items : items.slice(0, maxVisibleChips);

  return (
    <div
      ref={containerRef}
      className={`flex flex-wrap gap-2 ${containerClass}`}
      style={{ padding: "0 10px" }}
    >
      {displayedItems.map((item, index) => (
        <MemoizedChip
          key={index}
          ref={(el) => (chipRefs.current[index] = el)}
          size="small"
          variant="outlined"
          style={{ margin: "2px", wordBreak: "break-word" }}
          label={item}
        />
      ))}

      {items.length > maxVisibleChips && (
        <Button
          ref={seeMoreRef}
          onClick={() => setExpanded((prev) => !prev)}
          variant="text"
          color="secondary"
          size="small"
          style={{ whiteSpace: "nowrap" }}
        >
          {expanded ? "See Less" : "See More"}
        </Button>
      )}
    </div>
  );
};

export default memo(ExpandableChips);
